<div #animatedDigit>
  <span>{{ digit }}</span>
</div>
